import {ActivatedRoute} from '@angular/router';
import {Component, OnInit} from '@angular/core';
import {EvaluationService} from '../../services/evaluation.service';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
  styleUrls: ['./evaluated-refrigerator-details.component.scss'],
  templateUrl: './evaluated-refrigerator-details.component.html'
})
export class EvaluatedRefrigeratorDetailsComponent implements OnInit {
  detail: any;
  data: any;
  keys = [{key: 'year', label: 'Έτος κατασκευής'}, {key: 'hasLight', label: 'Φωτιζόμενο'}, {
    key: 'internalWhite',
    label: 'Εσωτερικά λευκό'
  }, {key: 'internalLook', label: 'Εσωτερική εμφάνιση'}, {key: 'externalLook', label: 'Εξωτερική εμφάνιση'}, {
    key: 'windowState',
    label: 'Κατάσταση τζαμιών'
  }, {key: 'neckState', label: 'Κατάσταση περιλαιμίου'}];

  constructor(private activatedRoute: ActivatedRoute,
              private evaluationService: EvaluationService,
              private toastMessagesService: ToastMessagesService) {
  }

  public async ngOnInit(): Promise<void> {
    try {
      const recordId = await this.subscribeToRouteParams();
      this.detail = await this.initDetails(+recordId);
      this.data = this.detail.data !== 'null' ? JSON.parse(this.detail.data) : null;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initDetails(recordId: number): Promise<any> {
    return await this.evaluationService.fetchRefrigeratorDetails(recordId);
  }

  subscribeToRouteParams() {
    return new Promise(resolve => {
      this.activatedRoute.params.subscribe(params => {
        resolve(+params.id);
      });
    });
  }

  fetchColor() {
    switch (this.detail.category) {
      case 'A':
        return 'green';
      case 'B':
        return 'orange';
      case 'C':
        return 'red';
      case 'X':
        return 'red';
    }
  }
}
